var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    breakpoints = _ref.breakpoints;
  return {
    contentBackgroundColor: colors.contrasts.white1010,
    contentPaddingTopBottom: spacing.medium,
    contentPaddingLeftRight: spacing.medium,
    breadCrumbMarginBottom: spacing.large,
    bankNamePaddingBottom: spacing.large,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    phoneContentPadding: spacing.small,
    filtersMarginTop: spacing.large
  };
};
export default generateComponentTheme;